<div class="col-md-12 padding-left-0px padding-right-0px margin-bottom-5px" >
  <div class="row margin-left-0px">
    <div class="col-md-5 padding-left-0px padding-right-0px text-align-left">
      <label class="margin-bottom-0px font-family"><span>*</span> {{field.Title}}</label>
    </div>

    <div class="col-md-6 padding-left-0px padding-right-0px">
      <select class="form-control" name="value" [(ngModel)]="field.Value">

        <option *ngFor="let R of Data.ValueSourceList" [value]="R"
                [selected]="R ===  field.Value ">
          {{R}}
        </option>

      </select>
      <!--
               (change)="onChange($event.target.value)"
      <CodeTypeValue [CodeType]="field.ValueSource"
                 id="CurrentActorAddEmergencyInfoRequest.RelationType"
                 [(ngModel)]="field.Value" SelectedValue="field.Value"
                 name="field.Value">
  </CodeTypeValue>-->


    </div>
  </div>


</div>
<!--<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf="FormMode=='View'">
  <div class="row">
    <div class="col-md-3 text-align-right">
      <label for="diaplayName"><span>*</span> {{field.Title}}</label>
    </div>

    <div class="col-md-4">
      <label for="diaplayName"><span>*</span> {{field.Value}}</label>
      

    </div>
  </div>


</div>-->
